@if (!hasNoContent()) {
<ob-alert type="error">{{ "i18n.table.required.text" | translate }}</ob-alert>
}
